<template>
<div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="70vh">
      <el-table-column prop="house_name" label="房产" width="300"></el-table-column>
      <el-table-column prop="meter_energy_name" label="能耗类型 " width="100"></el-table-column>
      <el-table-column prop="meter_type_name" label="仪表类型" width="100"></el-table-column>
      <el-table-column prop="number" label="仪表编号 "  width="150">
        <template slot-scope="scope">
          <el-link type="primary">{{scope.row.number}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="180"></el-table-column>
      <el-table-column prop="position" label="位置" width="100"></el-table-column>
      <el-table-column prop="children_count" label="下级数量" width="100"></el-table-column>
      <el-table-column label="操作 ">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showMap(scope.row)" >架构图</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>
  <MeterViewDiagramWindow ref="MeterViewDiagramWindow" />
</div>
</template>

<script>
import MeterViewDiagramWindow from "./components/MeterViewDiagramWindow";
export default {
  name: "MeterViewMapList",
  components: {MeterViewDiagramWindow},
  props:{
    batch_number:[String,Number]
  },
  data(){
    return{
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = {
        batch_number:that.batch_number,
      };
      ERP.postRequest({
        url: "admin/Meter/getBatchNumberMeterLevelOne",
        data: {
          ...where,
          page: this.pageData.page,
          pageSize: this.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    showMap(item){
      const that=this;
      ERP.showLoading();
      that.$refs.MeterViewDiagramWindow.show(item.batch_number,item.number,ret=>{
        ERP.hideLoading();
      })
    },
    edit(item) {
      this.$refs.MeterInfo.show(item);
    },
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterViewMapList.vue